/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Validation_Messagemin1Inputs */

const he_contact_validation_messagemin1 = /** @type {(inputs: Contact_Validation_Messagemin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההודעה חייבת להכיל לפחות 10 תווים`)
};

const en_contact_validation_messagemin1 = /** @type {(inputs: Contact_Validation_Messagemin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message must be at least 10 characters`)
};

/**
* | output |
* | --- |
* | "Message must be at least 10 characters" |
*
* @param {Contact_Validation_Messagemin1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_validation_messagemin1 = /** @type {((inputs?: Contact_Validation_Messagemin1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Validation_Messagemin1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_validation_messagemin1(inputs)
	return en_contact_validation_messagemin1(inputs)
});
export { contact_validation_messagemin1 as "contact_validation_messageMin" }